import Oidc from 'oidc-client';

export interface OidcOptions {
    userManagerSettings: Oidc.UserManagerSettings;
}

let options: OidcOptions;
let oidcUserManager: Oidc.UserManager;

export function init(configure: (options: OidcOptions) => void) {
    if (oidcUserManager == null) {
        if (options == null) {
            options = {
                userManagerSettings: {
                    response_type: 'id_token token',
                    scope: 'openid',
                },
            };
        }
        configure(options);
        oidcUserManager = new Oidc.UserManager(options.userManagerSettings);
    }
}

export function signin() {
    return oidcUserManager.signinPopup();
}

export function signinSilent() {
    return oidcUserManager.signinSilent(options.userManagerSettings);
}

export function signout() {
    return oidcUserManager.signoutRedirect();
}

export function getUserManager() {
    return oidcUserManager;
}

export function getUser() {
    return oidcUserManager.getUser();
}

export async function checkToken() {
    let user = await checkAuthentication(true);
    if (user && user.access_token && user.expires_in >= 60) {
        return user.access_token;
    }
}

export async function checkUserInfo() {
    let user = await checkAuthentication();
    if (user && user.access_token && user.expires_in >= 60) {
        return user.profile;
    }
}

export async function checkAuthentication(dontUseSilentSignin = false) {
    let user = await oidcUserManager.getUser();
    if (user && user.access_token && user.expires_in >= 60) {
        return user;
    }

    // Start a silent authentication to renew the token _or_ redirect the user to signin.
    if (user && !dontUseSilentSignin) {
        return await oidcUserManager.signinSilent(options.userManagerSettings);
    }
}

export async function checkRedirect() {
    console.log(
        window.location.href == options.userManagerSettings.redirect_uri
    );
    console.log(
        window.location.href == options.userManagerSettings.silent_redirect_uri
    );
    return false;
}
